<template>
  <div class="login">
    <md-field>
      <md-input-item ref="input0" v-model="userName" placeholder="请输入用户名/邮箱"
        @change="checkBankCard">
        <img src="@/assets/image/icon_email.png" alt="" slot="left" class="logo" />
        <p v-if="isError" class="error" slot="error">
          请输入用户名/邮箱/手机
        </p>
      </md-input-item>
      <md-input-item ref="input0" v-model="passWord" placeholder="請輸入密碼"
        :type="showpass ? 'password' : 'text'" @change="checkBankpassWord">
        <md-icon :name="showpass ? 'invisible' : 'visible'" size="lg" slot="right"
          @click="showpass = !showpass"></md-icon>
        <img src="@/assets/image/icon_pwd.png" alt="" slot="left" class="logo" />
        <p v-if="isErrorpas" class="error" slot="error">
          請輸入密碼
        </p>
      </md-input-item>
    </md-field>
    <div>
      <md-button :type="
          !isError && !isErrorpas && userName && passWord
            ? 'warning'
            : 'disabled'
        " round style="width: 90%;margin-left: 5%;height: 0.9rem" @click="login">
        <md-activity-indicator v-if="loading" class="md-activity-indicator-css" type="carousel"
          :size="15" color="#fff" text-color="#fff"></md-activity-indicator>
        <span v-else>登录</span>
      </md-button>
    </div>
  </div>
</template>

<script>
import {
  ActivityIndicator,
  Button,
  Field,
  FieldItem,
  Icon,
  InputItem,
} from 'mand-mobile';
import md5 from 'js-md5';

export default {
  name: 'LoginModal',
  components: {
    [Field.name]: Field,
    [InputItem.name]: InputItem,
    [FieldItem.name]: FieldItem,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [ActivityIndicator.name]: ActivityIndicator,
  },
  data() {
    return {
      showpass: true,
      isError: false,
      isErrorpas: false,
      userName: '',
      loading: false,
      passWord: '',
    };
  },
  props: {
    // 店铺参数
    shopkey: {},
  },
  methods: {
    checkBankpassWord() {
      if (!this.passWord) {
        this.isErrorpas = true;
      } else {
        this.isErrorpas = false;
      }
    },
    checkBankCard() {
      var reg = new RegExp(
        '^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$'
      );
      if (!this.userName) {
        this.isError = true;
      } else {
        this.isError = false;
      }
    },
    login() {
      this.loading = true;
      const par = {
        userName: this.userName.trim(),
        passWord: md5(this.passWord),
        shopCode: this.shopkey.appCode,
        countryId: this.$route.query.id
          ? this.$route.query.id
          : localStorage.getItem('firconteid'),
        registeredPlace: this.$route.query.pagename
          ? this.$route.query.pagename
          : localStorage.getItem('fircontename'),
      };
      this.http
        .APIASK(this.ports.appLogin, 'post', par)
        .then((res) => {
          if (res.object) {
            localStorage.setItem('couplist', JSON.stringify(res.object));
          }
          localStorage.setItem('mupressMobiltoken', res.accessToken);
          localStorage.setItem('refreshToken', res.refreshToken);
          const headerParams = {
            Authorization: res.accessToken,
            refreshToken: res.refreshToken,
            platform: 'H5',
            platformObj: {},
          };
          localStorage.setItem('headerParams', JSON.stringify(headerParams));
          this.getUserInfo();
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getUserInfo() {
      this.http
        .APIASK(this.ports.getUserInfo, 'get')
        .then((res) => {
          localStorage.setItem('userinfoMobie', JSON.stringify(res));
          this.loading = false;
          this.$emit('getnext');
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less">
.logo {
  width: 0.55rem;
  height: auto;
}
.error {
  text-align: left;
}
</style>
